var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('iframe',{attrs:{"src":"https://alidocs.dingtalk.com/i/nodes/NkDwLng8ZLxDOvXZTapbEMBqVKMEvZBY?utm_scene=team_space","frameborder":"0"}})])
}]

export { render, staticRenderFns }